import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { apiEndpoint } from 'configs'

const purchaseCommodityCheckUser = createAsyncThunk(
  'purchase/commodity/checkUser',
  async ({ search, type }, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }

      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/bussines/transaction/checkuser?search=${search}&type=${type}`,
        config,
      )
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

const getUnits = createAsyncThunk(
  'purchase/commodity/units',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `https://kelud.pasarmikro.id:9443/api/v1/public`,
      )
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

const createOrderStaff = createAsyncThunk(
  'purchase/commodity/order/staff',
  async (payload, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }

      const { dashboard } = getState()
      const buyerData =
        payload.buyer || dashboard.ownerData || dashboard.profile?.data?.ownerData

      let result = {
        ...payload,
        order: {
          ...payload.order,
          files: payload.order?.files || [],
        },
        userId: buyerData?.userId || payload.userId,
        buyer: {
          fullName: buyerData?.name || buyerData?.fullName,
          phoneNumber: buyerData?.phoneNumber,
          userId: buyerData?.userId,
        },
        item: payload.item?.map((i) => ({
          orderItemId: i.orderItemId,
          SKU: i.SKU,
          amount: i.amount,
          // imageUrl: i.imageUrl,
          // nameItem: i.nameItem,
          price: i.price,
          totalPrice: i.totalPrice,
          unit: i.unit.value,
        })),
      }

      const { data } = await axios.post(
        `${apiEndpoint}/api/v1/bussines/transaction/buy`,
        result,
        config,
      )

      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

const getComodities = createAsyncThunk(
  'purchase/commodity/comodities',
  async ({ isProductionUnit }, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }

      // LOCAL STORAGE
      const storedFrequentItems =
        JSON.parse(localStorage.getItem('lastPickedCommoditiesBuy')) || []

      // GET FREQUENT ITEMS FROM API
      let frequentItemsFromAPI = []
      try {
        const resFrequent = await axios.get(
          `${apiEndpoint}/api/v1/bussines/item-frequent?type=buy`,
          config,
        )

        frequentItemsFromAPI = resFrequent.data.map((e) => ({
          value: e.id,
          label: e.nameItem,
          id: e.id,
          img: e.linkFoto,
          sku: e.SKU,
          agencyModel: e.agencyModel,
        }))
      } catch (error) {
        console.warn('Error fetching frequent items:', error)
      }

      // GET ALL ITEMS FROM API
      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/bussines/items?origin=true&sortby=nameItem&sortdir=asc`,
        config,
      )

      let allItems = data.items
      if (data.totalItems > data.items.length) {
        const res = await axios.get(
          `${apiEndpoint}/api/v1/bussines/items?origin=true&sortby=nameItem&sortdir=asc&size=${data.totalItems}`,
          config,
        )
        allItems = res.data.items
      }

      // LOOKUP
      const allItemsMap = new Map()
      allItems.forEach((item) => {
        allItemsMap.set(item.id, {
          value: item.id,
          label: item.nameItem,
          id: item.id,
          img: item.linkFoto,
          sku: item.SKU,
          agencyModel: item.agencyModel,
        })
      })

      // UPDATE AND VALIDATE STORED FREQUENT ITEMS
      const updatedStoredItems = storedFrequentItems
        .map((storedItem) => {
          // CHECK IF ITEM STILL EXISTS IN MASTER ITEMS
          const validItem = allItemsMap.get(storedItem.id)
          if (!validItem) {
            return null
          }

          // UPDATE WITH LATEST DATA FROM MASTER ITEMS
          return {
            ...validItem,
          }
        })
        .filter((item) => item !== null)

      // MERGE WITH FREQUENT ITEM FROM API, AVOIDING DUPLICATES
      const mergedFrequentItems = [...updatedStoredItems]

      // ADD API FREQUENT ITEMS THAT ARE NOT ALREADY IN STORED ITEMS
      frequentItemsFromAPI.forEach((apiItem) => {
        const existsInStored = updatedStoredItems.some(
          (stored) => stored.id === apiItem.id,
        )
        if (!existsInStored) {
          mergedFrequentItems.push(apiItem)
        }
      })

      // LIMIT TO 5 ITEMS AND ENSURE UNIQUENESS
      const finalFrequentItems = mergedFrequentItems
        .filter(
          (item, index, self) =>
            index === self.findIndex((i) => i.id === item.id),
        )
        .slice(0, 5)

      // UPDATE LOCAL STORAGE WITH VALIDATED AND UPDATED FREQUENT ITEMS
      localStorage.setItem(
        'lastPickedCommoditiesSell',
        JSON.stringify(finalFrequentItems),
      )

      // PREPARE ALL OTHER ITEMS (EXCLUDING FREQUENT ITEMS)
      const allMappedItems = allItems
        .map((e) => ({
          value: e.id,
          label: e.nameItem,
          id: e.id,
          img: e.linkFoto,
          sku: e.SKU,
          agencyModel: e.agencyModel,
        }))
        .filter(
          (item) =>
            !finalFrequentItems.some((frequent) => frequent.id === item.id),
        )

      if (isProductionUnit) {
        return [
          {
            label: 'SEMUA BARANG',
            options: [...allMappedItems, ...finalFrequentItems],
          },
        ]
      } else {
        return [
          {
            label: 'TERAKHIR/SERING DIPILIH',
            options: finalFrequentItems,
          },
          {
            label: 'SEMUA BARANG',
            options: allMappedItems,
          },
        ]
      }
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

const uploadFile = createAsyncThunk(
  'purchase/commodity/upload',
  async (payload, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${auth.token}`,
        },
      }

      const formData = new FormData()
      formData.append('file', payload)

      const { data } = await axios.post(
        `${apiEndpoint}/api/v1/upload`,
        formData,
        config,
      )

      const fileUrl =
        data?.url || data?.data?.url || (typeof data === 'string' ? data : null)
      if (!fileUrl) {
        return rejectWithValue(
          'Respon server upload tidak memiliki URL file yang valid',
        )
      }

      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

// Export the functions
export {
  createOrderStaff,
  getComodities,
  getUnits,
  purchaseCommodityCheckUser,
  uploadFile,
}
